module.exports = __webpack_public_path__ + "static/img/componylogo.7707e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/componylogo.png
// module id = hTlX
// module chunks = 1